import React from "react";

export function AccountItemLine({ title, children, dataTestId }) {
  return (
    <div
      data-testid={dataTestId}
      className="text-primary py-xs text-xs md:text-sm flex flex-row space-x-sm items-center w-full"
    >
      {title ? <strong className="mr-sm">{title}</strong> : null}{" "}
      {children}
    </div>
  );
}

export function AccountItemBlock({ title, desc, children }) {
  return (
    <div className="text-primary py-xs flex flex-col md:flex-row space-y-sm w-full">
      {(title || desc) && (
        <span className="text-xs md:text-sm my-sm md:w-64 shrink-0">
          {title ? <strong className="mr-sm">{title}</strong> : null}
          <span className="text-secondary">{desc ? desc : null}</span>
        </span>
      )}

      <div className="flex-1 md:ml-lg">{children}</div>
    </div>
  );
}

export function AccountItem({ title, children, icon }) {
  return (
    <div
      className={
        "flex flex-col lg:flex-row border rounded-standard border-secondary p-md shadow-xs lg:items-center"
      }
    >
      <div
        className={
          "mr-sm mb-md lg:mb-0 lg:mr-lg self-start lg:w-44 flex flex-row items-baseline"
        }
      >
        {icon}
        <h3 className="ml-sm md:ml-md text-base md:text-xl">
          {title}
        </h3>
      </div>
      <div className="flex flex-1 flex-col lg:flex-row lg:items-center space-y-sm lg:space-y-0 space-x-md">
        {children}
      </div>
    </div>
  );
}
